import React, { useContext } from 'react';

import NavButton from 'components/nav-button/NavButton';

import logo from "assets/TechTutzLogo.png";

import SpinningImage from 'views/home/SpinningImage';

import GlobalContext from 'GlobalContext';

import './Home.scss';

const HomePage = () => {
  const { darkMode } = useContext(GlobalContext);

  return (
    <section className={darkMode ? 'home-page-dark' : 'home-page'}>
      <div className="big-section">
        <SpinningImage src={logo} />
      </div>
      <div className="small-section">
        <p>A fresh take on learning web development</p>
      </div>
      <div className="landing-page-buttons">
        <NavButton buttonText="Try It" toLocation={'/infobook'} />
        <NavButton buttonText="About" toLocation={'/about'} />
      </div>
    </section>
  );
};

export default HomePage;
